
export const Date_Formats = {
    parse: {
      dateInput: 'DD-MM-YYYY'
    },
    display: {
      dateInput: 'DD-MM-YYYY',
      monthYearLabel: 'MM YYYY',
      dateA11yLabel: 'LL',
      monthYearA11YLabel: 'MM YYYY'
    }
  }